import { Pipe, PipeTransform } from '@angular/core';
import { UserTypeEnum } from '@app/enum/UserTypeEnum';

@Pipe({
  name: 'addFilterUserDataList',
  pure: false,
})
export class AddFilterUserDataList implements PipeTransform {
  transform(fullList: any[], addedtemsList: any[], filterText = '', ignoreProfessional = false): any {
    let newList = [];

    fullList.forEach((element) => {
      if (addedtemsList.findIndex((x) => x.id == element.id || x.user_id == element.user_id) == -1) {
        newList.push(element);
      }
    });

    if (filterText?.length) {
      let filterItems = [];
      if (ignoreProfessional) {
        filterItems = newList.filter((relationship) => {
          let relationshipName = '';
          if (relationship.user_first_middle_name && relationship.user_last_name) {
            relationshipName = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
          } else if (relationship.name) {
            relationshipName = relationship.name;
          }
          // Split the search text into words and check if all words are present
          const searchWords = filterText
            .toLowerCase()
            .split(' ')
            .filter((word) => word.length > 0);
          return searchWords.every((word) => relationshipName?.toLowerCase()?.includes(word));
        });
      } else {
        filterItems = newList
          .filter((x) => {
            if (x.user_type) {
              return x.user_type != UserTypeEnum.Professional;
            }
            return true;
          })
          .filter((relationship) => {
            let relationshipName = '';
            if (relationship.user_first_middle_name && relationship.user_last_name) {
              relationshipName = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
            } else if (relationship.name) {
              relationshipName = relationship.name;
            }
            // Split the search text into words and check if all words are present
            const searchWords = filterText
              .toLowerCase()
              .split(' ')
              .filter((word) => word.length > 0);
            return searchWords.every((word) => relationshipName?.toLowerCase()?.includes(word));
          });
      }

      return filterItems;
    } else {
      return newList;
    }
  }
}
